import { memo } from "react";
import { Handle, Position } from "reactflow";
import CoupleCard from "./CoupleCard";
import { Person } from "../types/person";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { IconButton } from "@mui/material";

interface Props {
  data: {
    partner1: Person;
    partner2?: Person;
    onPersonClick?: (person: Person) => void;
    onExpand?: () => void;
    gen: number; // generation index (0=root)
    formatPersonSubtitle?: (person: Person) => string;
    coupleNodeWidth?: number;
  };
}

function CoupleNode({ data }: Props) {
  const {
    partner1,
    partner2,
    onPersonClick,
    onExpand,
    gen,
    formatPersonSubtitle,
    coupleNodeWidth,
  } = data;

  return (
    <div style={{ position: "relative" }}>
      <Handle type="target" position={Position.Left} />
      <CoupleCard
        partner1={partner1}
        partner2={partner2}
        onPersonClick={onPersonClick}
        formatPersonSubtitle={formatPersonSubtitle}
        coupleNodeWidth={coupleNodeWidth}
      />
      {/* Dad handle - positioned at top third of card for partner1 */}
      <Handle id="dad" type="source" position={Position.Top} />
      {/* Mom handle - positioned at bottom third of card for partner2 */}
      {partner2 && <Handle id="mom" type="source" position={Position.Bottom} />}
      {/* Expansion arrow appears on odd-numbered edge generations: gen 2,4,6...  */}
      {onExpand && gen >= 2 && gen % 2 === 0 && (
        <IconButton
          size="small"
          onClick={onExpand}
          sx={{
            position: "absolute",
            right: -32,
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "#fff",
            boxShadow: 3,
            "&:hover": { backgroundColor: "#f5f5f5" },
          }}
        >
          <ArrowForwardIosIcon fontSize="inherit" />
        </IconButton>
      )}
      {/* source handle aligned with arrow centre */}
      {onExpand && gen >= 2 && gen % 2 === 0 && (
        <Handle
          id="arrow"
          type="source"
          position={Position.Right}
          style={{ top: "50%" }}
        />
      )}
    </div>
  );
}

export default memo(CoupleNode);
